export const cookieVariables = {
  auth: 'auth',
  lang: 'limehome-lang',
  voucherCode: 'limehome-voucherCode',
  isUserInternal: 'limehome-user-internal',
  newsletterOnlyUser: 'limehome-newsletter-only-user',
  isNativeAppKey: 'isNativeApp',
  identityId: 'limehome-identity-id'
};
